import React from 'react';

const variantClasses = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 disabled:opacity-50 shadow-sm',
  secondary: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 active:bg-gray-100',
  ghost: 'text-gray-600 hover:bg-gray-100 active:bg-gray-200',
  danger: 'bg-danger-500 text-white hover:bg-danger-600 active:bg-danger-700',
  whatsapp: 'bg-whatsapp-500 text-white hover:bg-whatsapp-600 active:bg-whatsapp-700 shadow-sm',
};

const sizeClasses = {
  default: 'p-3 rounded-lg font-medium',
  sm: 'px-3 py-1.5 rounded-lg text-sm font-medium',
};

const Button = ({ variant = 'primary', size = 'default', className = '', children, ...props }) => (
  <button
    className={`${variantClasses[variant] || ''} ${sizeClasses[size] || ''} transition-colors disabled:cursor-not-allowed ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
